import contentService from '../services/contentService'

// Hitos de aprobación (mismos colores/labels que la pantalla /aprobaciones).
export const HITOS = {
  idea_creativa: { label: 'Idea Creativa', color: '#7C3AED', bg: '#F5F3FF', icon: 'bi-lightbulb' },
  copy:          { label: 'Copy',          color: '#0369A1', bg: '#F0F9FF', icon: 'bi-pencil' },
  contenido:     { label: 'Contenido',     color: '#B45309', bg: '#FFFBEB', icon: 'bi-camera-reels' },
  // Solo en "pendientes de enviar": hay archivos rechazados que el editor debe reemplazar.
  contenido_rechazado: { label: 'Contenido rechazado', color: '#B91C1C', bg: '#FEF2F2', icon: 'bi-arrow-repeat' },
}

// Grupos que habilitan aprobar cada hito (igual que PostDetailModal).
export const GRUPOS_APROBADORES = {
  idea_creativa: 'Aprobadores Idea Creativa',
  copy: 'Aprobadores Copy',
}

export function permisosAprobacion(user) {
  const grupos = user?.groups || []
  return {
    idea_creativa: grupos.includes(GRUPOS_APROBADORES.idea_creativa),
    copy: grupos.includes(GRUPOS_APROBADORES.copy),
    contenido: false, // los archivos se revisan en el detalle del post
  }
}

export function fmtFecha(iso) {
  if (!iso) return '—'
  const [y, m, d] = iso.split('-')
  return `${d}/${m}/${y}`
}

export function diasRestantes(iso) {
  if (!iso) return null
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0)
  const pub = new Date(iso + 'T00:00:00')
  return Math.round((pub - hoy) / 86400000)
}

export function textoDias(dias) {
  if (dias == null) return '—'
  if (dias === 0) return 'hoy'
  return dias < 0 ? `hace ${Math.abs(dias)}d` : `en ${dias}d`
}

// Más urgentes primero (publicación más próxima / más atrasada); sin fecha al final.
export const sortAprobaciones = (posts) =>
  [...posts].sort((a, b) => {
    if (!a.fecha_publicacion) return 1
    if (!b.fecha_publicacion) return -1
    return a.fecha_publicacion.localeCompare(b.fecha_publicacion)
  })

/** Posts con al menos un hito sin aprobar. Misma fuente que la pantalla /aprobaciones. */
export async function fetchAprobacionesPendientes() {
  const res = await contentService.getAprobacionesPendientes()
  return sortAprobaciones(res.data.posts || [])
}
